import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Box, Button, Card, InputBase, Dialog, DialogTitle, DialogContent, TextField, MenuItem, DialogActions, Typography, TableContainer, Paper, Table, TableHead, TableCell, TableBody, TableRow, Popover, DialogContentText, Grid, CircularProgress } from '@mui/material';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';

function SedSelfAssigned() {

    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [dailyData, setDailyData] = useState("");
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [allUpdates, setAllUpdates] = useState([]);
    const [view, setView] = useState([]);
    const [selectedLead, setSelectedLead] = useState("");
    const [formOpen, setFormOpen] = useState(false);
    const [seoType, setSeoType] = useState("Google Business Profile");

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [fileUpload, setFileUpload] = useState(null);
    const [assignedLeads, setAssignedLeads] = useState([]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const UserId = sessionStorage.getItem('userId');
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [seoData, setSeoData] = useState([]);
    const userId = sessionStorage.getItem('userId');


    const [formData, setFormData] = useState({
        completedKeywords: "",
        fileUpload: "",
        progress: '',
        status: "",
        contentStatus: '',
        comments: ''
    });

    const [newEvent, setNewEvent] = useState({
        title: '',
        start: '',
        extendedProps: { hours: '', color: '#B28DFF' },
        status: ''
    });

    console.log(view, "View");


    const handleOpenMenu = (event, task, id, workUpdateId) => {
        debugger;
        let lead;

        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpenMenu(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task);
        }
    };

    const handleCloseMenu = () => {
        setOpenMenu(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    };

    const handleClose = () => {
        setFormOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const getAllLeads = async (skip = currentPage) => {
        const parmas = {
            page: skip,
            limit: limit
        }
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData(`leads/leads/${userId}`, parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data[0]?.paginatedResults || [];

            setSeoData(responseData)
            setTotalPages(response.data[0].totalPages);
            setTotalCount(response.data[0].totalCount.totalItems);

        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    useEffect(() => {
        getAllLeads(currentPage, limit);
    }, [currentPage, limit, roleType]);

    const getDailyUpdates = async () => {
        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            setDailyData(response?.data);
        } catch (err) {
            console.error("Error while fetching daily updates:", err);
            toast.error("Failed to load daily updates.");
        }
    };

    const getAllUpdatesAdmin = async () => {
        const params = {
            page: 1,
            limit: 1000
        };

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            const filteredData = response?.data[0]?.paginatedResults?.filter(
                lead => lead.serviceName === "SEO" && lead.seoType === seoType
            );
            setAllUpdates(filteredData);
            setView(filteredData);
        } catch (err) {
            console.error("Error while fetching updates:", err);
            toast.error("Failed to load updates.");
        }
    };

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    const postDailyWorkUpdate = async () => {
        debugger
        try {
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.seoHistory?.map(history => history?.dailyUpdateId));

            const seoType = selectedLead?.seoHistory?.[0]?.seoType ||
                selectedLead?.seoHistory?.[0]?.seoType ||
                {};
            const seoPackageType = selectedLead?.seoHistory?.[0]?.seoPackageType ||
                selectedLead?.seoHistory?.[0]?.seoPackageType ||
                {};
            const targetKeywords = selectedLead?.seoHistory?.[0]?.targetKeywords ||
                selectedLead?.seoHistory?.[0]?.targetKeywords ||
                {};
            const totalKeywords = selectedLead?.seoHistory?.[0]?.totalKeywords ||
                selectedLead?.seoHistory?.[0]?.totalKeywords ||
                10;

            const seoHistory = selectedLead?.seoHistory?.[0] ||
                selectedLead?.seoHistory ||
                {};
            const previousCompleted = seoHistory.completedKeywords || 0;
            const newCompleted = parseInt(formData.completedKeywords, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;

            const status = selectedLead?.seoHistory?.[0]?.completedKeywords === selectedLead?.seoHistory?.[0]?.totalKeywords ? "Completed" : "In Progress";

            const payLoad = {
                totalKeywords,
                seoPackageType,
                targetKeywords,
                completedKeywords: totalCompleted,
                fileUpload: fileUpload,
                status,
                // contentStatus: formData.contentStatus,
                comments: formData.comments,
                serviceName: "SEO",
                seoType,
                leadId: selectedLeadId,
                userId: UserId
            };

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                const updateId = existingUpdates[existingUpdates.length - 1];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
                getAllLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message);
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    return (
        <>
            <Helmet>
                <title>SEO Self Assigned</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        SEO Self Assigned
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Lead</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Package Type</TableCell>
                                {/* <TableCell>Backlink Status</TableCell> */}
                                {/* <TableCell>SEO Audit Status</TableCell> */}
                                <TableCell>Assigned Keywords</TableCell>
                                <TableCell>Deadline</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    seoData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        seoData?.map((task, id) => {
                                            const seoData = task.seoHistory?.find(seo => seo.seoType === seoType) || {};
                                            return (
                                                <TableRow key={task?.id}>
                                                    <TableCell align="center">{calculateIndex(id)}</TableCell>
                                                    <TableCell align="center">{task?.name}</TableCell>
                                                    <TableCell align="center">{task?.phone}</TableCell>
                                                    <TableCell align="center">{task?.seoHistory[0]?.seoPackageType}</TableCell>
                                                    <TableCell align='center'>{task?.currentWork?.noOfPosters}</TableCell>
                                                    <TableCell align='center'>{task?.currentWork !== null ? new Date(task?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                    <TableCell align="center">
                                                        <Box position="relative" display="inline-flex">
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={task?.seoHistory[0]?.progress}
                                                            />
                                                            <Box
                                                                top={0}
                                                                left={0}
                                                                bottom={0}
                                                                right={0}
                                                                position="absolute"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                    {typeof task?.seoHistory[0]?.progress === 'number'
                                                                        ? `${Math.round(task.seoHistory[0].progress)}%`
                                                                        : '0%'}
                                                                </Typography>

                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Iconify
                                                            icon="material-symbols-light:more-vert"
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, task, task._id, seoData?.dailyUpdateId)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <PaginationComponent
                        name={"Services"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(openMenu)}
                    anchorEl={openMenu}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <MenuItem onClick={handleOpenDialog}>
                        <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                        View
                    </MenuItem>
                    <MenuItem onClick={handleOpen}>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                        Work Update
                    </MenuItem>
                </Popover>

                {/* View Dialog */}
                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Content Type: {view?.seoHistory[0]?.contentType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.seoHistory[0]?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.seoHistory[0]?.status === 'Completed' ? 'success.main' :
                                                            view?.seoHistory[0]?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.seoHistory[0]?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    SEO Focus: {view?.seoHistory[0]?.seoFocus}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Tasks: {view?.seoHistory[0]?.completedKeywords}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Tasks: {view?.seoHistory[0]?.totalTasks}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.seoHistory[0]?.progress}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.seoHistory[0]?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.seoHistory[0]?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                {/* Work Update Form Dialog */}
                <Dialog
                    open={formOpen}
                    onClose={handleClose}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">Daily Work Update!</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                        >
                            <TextField
                                margin="dense"
                                label="Completed Tasks"
                                name="completedKeywords"
                                value={formData.completedKeywords}
                                onChange={handleChange}
                                type="number"
                                fullWidth
                            />

                            {/* <TextField
                                margin="dense"
                                label="Progress Percentage"
                                name="progressPercentage"
                                value={formData.progressPercentage}
                                onChange={handleChange}
                                type="number"
                                fullWidth
                            /> */}

                            {/* <TextField
                                margin="dense"
                                label="Status"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                select
                                fullWidth
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                            </TextField> */}

                            {/* <TextField
                                margin="dense"
                                label="Content Status"
                                name="contentStatus"
                                value={formData.contentStatus}
                                onChange={handleChange}
                                select
                                fullWidth
                            >
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                            </TextField> */}
                            <TextField
                                margin="dense"
                                label="Comments"
                                name="comments"
                                value={formData.comments}
                                onChange={handleChange}
                                multiline
                                fullWidth
                            />
                            <TextField
                                margin='dense'
                                type='file'
                                hidden
                                label="Upload File"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => handleFileChange(e)}
                            >
                            </TextField>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={postDailyWorkUpdate}>Submit</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
}

export default SedSelfAssigned;
